import { cronosClient } from "@/config/client"
import type { CourseStatus } from "@/services/api/cronos/tracking/students/get-situation"
import type { CourseTargetObjetive } from "./get"

interface BySubjectParam {
  subjectId: string
}

interface ByCourseParam {
  courseId: string
}

type GetUserReportsParam = BySubjectParam | ByCourseParam

export interface UserReport {
  userId: string
  courseId: string
  status: CourseStatus
  courseName: string
  firstName: string
  lastName: string
  emailAddress: string
  avatar: string
  targetObjective: CourseTargetObjetive
}

export function getUserReports(param: GetUserReportsParam) {
  return cronosClient.get<UserReport[]>("/v1/courses/user-reports", { params: param })
}
